import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollSmoother from 'gsap/ScrollSmoother';
import SplitText from 'gsap/SplitText';
import TextPlugin from 'gsap/TextPlugin';
// import Lenis from '@studio-freight/lenis';
import SplitType from 'split-type';

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText, TextPlugin);



// // Expose GSAP et ScrollTrigger à la console si besoin
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;


//
// ============================================
// 1. Effet Parallax horizontal sur .surtitre-gsap
// ============================================
// S'applique uniquement à partir de 768px de large
//

ScrollTrigger.matchMedia({
    "(min-width: 768px)": function () {
        const sliderSection = document.querySelector('.pdw-section-slider');
        if (!sliderSection) return;

        const images = sliderSection.querySelectorAll('.slider-image');
        if (!images.length) return;

        images.forEach((img) => {
            gsap.fromTo(
                img,
                { scale: 1 },
                {
                    scale: 1.2,
                    ease: "none",
                    scrollTrigger: {
                        trigger: sliderSection,
                        start: "top top",
                        end: "top+=700 top",
                        scrub: true
                    }
                }
            );
        });
    }
});

// ============================================
// 2. Scroll Effects sur .pdw-section-slider
// ============================================
document.addEventListener('DOMContentLoaded', () => {

    // Détection Safari
    function isSafari() {
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }

    // Appliqués uniquement à partir de 768px de large
    ScrollTrigger.matchMedia({
        "(min-width: 768px)": function () {
            const sliderSection = document.querySelector('.pdw-section-slider');
            const content = sliderSection?.querySelector('.slider-content-wrapper');
            const image = sliderSection?.querySelector('.slider-image');

            if (!sliderSection || !content || !image) return;

            // === 2.1 Overlay sombre progressif ===
// ScrollTrigger.create({
//     trigger: sliderSection,
//     start: 'top+=100 top',
//     end: 'top+=700 top',
//     scrub: true,
//     onUpdate: (self) => {
//         const progress = self.progress.toFixed(2);
//         sliderSection.style.setProperty('--overlay-opacity', progress);
//     }
// });

            // === 2.1 bis : Scale de l'image d'arrière-plan ===
            gsap.to(image, {
                scale: 1.2,
                ease: "none",
                scrollTrigger: {
                    trigger: sliderSection,
                    start: 'top+=0 top',
                    end: 'top+=700 top',
                    scrub: true
                }
            });

    /*        // === 2.2 Parallaxe verticale sur le contenu ===
            gsap.to(content, {
                y: -300,
                ease: "none",
                scrollTrigger: {
                    trigger: sliderSection,
                    start: 'top+=100 top',
                    end: 'top+=700 top',
                    scrub: true
                }
            });*/

            // === 2.3 Parallaxe sur la forme décorative (hors Safari) ===
            const shapeSection = document.querySelector('.pdw-section-presentation-avec-image');
            const shape = document.querySelector('.pdw-shape');

            if (shapeSection && shape && !isSafari()) {
                const scaleValue = window.innerWidth < 768 ? 5 : 15;

                gsap.to(shape, {
                    y: -350,
                    scale: scaleValue,
                    opacity: 0.3,
                    transformOrigin: 'center center',
                    ease: 'none',
                    scrollTrigger: {
                        trigger: shapeSection,
                        start: 'top 90%',
                        end: 'top -100%',
                        scrub: true
                    }
                });
            }
        }
    });

});


// Shape autres pages

// === 2.3 Parallaxe sur la forme décorative ===
// Détecte Safari
function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}

// Parallaxe uniquement si écran large, section et shape présents, et pas Safari
const shapeSection = document.querySelector('.pdw-section-presentation-avec-image');
const shape = document.querySelector('.pdw-shape-alt');

if (window.innerWidth >= 768 && shapeSection && shape && !isSafari()) {
    gsap.to(shape, {
        y: -350,
        scale: 16,
        opacity: 0.3,
        transformOrigin: 'center center',
        ease: 'none',
        scrollTrigger: {
            trigger: shapeSection,
            start: 'top -1%',
            end: 'top -100%',
            scrub: true
        }
    });
}

// Ideam pour le header des pages
// ScrollTrigger.matchMedia({
//     "(min-width: 768px)": function () {
//         const header = document.querySelector('.page-header.container-hero');
//         const image = header?.querySelector('.slider-image');
//
//         if (!header || !image) return;
//
//         gsap.to(image, {
//             scale: 1.8,
//             ease: "none",
//             scrollTrigger: {
//                 trigger: header,
//                 start: 'top top',
//                 end: 'top+=700 top',
//                 scrub: true
//             }
//         });
//     }
// });


//
// ============================================
// 3. Text Reveal avec SplitType (effet typographique)
// ============================================
// .reveal-type → data-bg-color et data-fg-color utilisés comme couleurs dynamiques
//
const splitTypes = document.querySelectorAll('.reveal-type');

splitTypes.forEach((el) => {
    const bg = el.dataset.bgColor || '#c8c8c8';
    const fg = el.dataset.fgColor || '#062B39';

    const split = new SplitType(el, {
        types: 'words chars',
        tagName: 'span'
    });

    // Chaque mot garde sa propre ligne
    el.querySelectorAll('.word').forEach(word => {
        word.style.whiteSpace = 'nowrap';
    });

    gsap.fromTo(
        split.chars,
        { color: bg },
        {
            color: fg,
            duration: 0.3,
            stagger: 0.02,
            scrollTrigger: {
                trigger: el,
                start: 'top 100%',
                end: 'top 20%',
                scrub: true
            }
        }
    );
});

//
// ============================================
// 4. Autre exemple de parallaxe verticale (commenté)
// ============================================
//
// gsap.to('.parallax-image', {
//   y: -600,
//   ease: 'none',
//   scrollTrigger: {
//     trigger: '.pdw-section-presentation-avec-image',
//     start: 'top bottom',
//     end: 'bottom top',
//     scrub: true,
//     // markers: true
//   }
// });



//



// Animation ligne timeline

gsap.utils.toArray('.vertical-line').forEach((line) => {
    gsap.to(line, {
        scaleY: 1,          // la ligne s'allonge
        ease: 'none',       // pas d'effet de vitesse, pour un scroll fluide
        scrollTrigger: {
            trigger: line,

            start: 'top bottom',  // début quand le haut de l'élément touche le bas du viewport
            end: 'bottom top',    // fin quand le bas de l'élément touche le haut du viewport
            ease: 'power2.out',
            scrub: 0.5,          // ⚡ synchronisé au scroll haut/bas
        }
    });
});



// Marqyyee On Scrol

document.addEventListener("DOMContentLoaded", () => {
    const rail = document.querySelector('.scrolling-text .rail');
    if (!rail) return;

    // Sélection initiale
    const originalItems = rail.querySelectorAll('h4');
    if (!originalItems.length) return;

    // Dupliquer le contenu pour effet continu
    const content = rail.innerHTML;
    rail.innerHTML += content;

    const scrollingText = gsap.utils.toArray('.scrolling-text .rail h4');

    // Lancer le scroll horizontal en boucle
    const tl = horizontalLoop(scrollingText, {
        repeat: -1,
    });

    let speedTween;

    // ScrollTrigger : accélère pendant le scroll
    ScrollTrigger.create({
        trigger: ".scrolling-text",
        start: "top bottom",
        end: "bottom top",
        onUpdate: (self) => {
            if (speedTween) speedTween.kill();

            speedTween = gsap.timeline()
                .to(tl, {
                    timeScale: 3 * self.direction,
                    duration: 0.25
                })
                .to(tl, {
                    timeScale: 1 * self.direction,
                    duration: 1.5
                }, "+=0.5");
        },
        markers: false
    });
});



// Fonction horizontale loop - Marqyyee On Scroll


function horizontalLoop(items, config) {
    items = gsap.utils.toArray(items);
    config = config || {};
    let tl = gsap.timeline({repeat: config.repeat, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
        length = items.length,
        startX = items[0].offsetLeft,
        times = [],
        widths = [],
        xPercents = [],
        curIndex = 0,
        pixelsPerSecond = (config.speed || 1) * 100,
        snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
        totalWidth, curX, distanceToStart, distanceToLoop, item, i;
    gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
        xPercent: (i, el) => {
            let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
            xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
            return xPercents[i];
        }
    });
    gsap.set(items, {x: 0});
    totalWidth = items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0);
    for (i = 0; i < length; i++) {
        item = items[i];
        curX = xPercents[i] / 100 * widths[i];
        distanceToStart = item.offsetLeft + curX - startX;
        distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
        tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
            .fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
            .add("label" + i, distanceToStart / pixelsPerSecond);
        times[i] = distanceToStart / pixelsPerSecond;
    }
    function toIndex(index, vars) {
        vars = vars || {};
        (Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
        let newIndex = gsap.utils.wrap(0, length, index),
            time = times[newIndex];
        if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
            vars.modifiers = {time: gsap.utils.wrap(0, tl.duration())};
            time += tl.duration() * (index > curIndex ? 1 : -1);
        }
        curIndex = newIndex;
        vars.overwrite = true;
        return tl.tweenTo(time, vars);
    }
    tl.next = vars => toIndex(curIndex+1, vars);
    tl.previous = vars => toIndex(curIndex-1, vars);
    tl.current = () => curIndex;
    tl.toIndex = (index, vars) => toIndex(index, vars);
    tl.times = times;
    tl.progress(1, true).progress(0, true); // pre-render for performance
    if (config.reversed) {
        tl.vars.onReverseComplete();
        tl.reverse();
    }
    return tl;
}



// Text animate - Start
const quotes = document.querySelectorAll(".quote");

function setupSplits() {
    quotes.forEach((quote) => {
        // Ne pas re-animer si déjà fait
        if (quote.dataset.splitDone === "true") return;

        // Attendre un layout stable
        requestAnimationFrame(() => {
            const split = new SplitText(quote, {
                type: "lines",
                linesClass: "split-line"
            });

            gsap.from(split.lines, {
                scrollTrigger: {
                    trigger: quote,
                    toggleActions: "restart none none none",
                    start: "top bottom",
                    once: true, // important : ne rejoue pas à chaque refresh
                    markers: false
                },
                duration: 0.8,
                ease: "circ.out",
                y: 60,
                opacity: 0,
                stagger: 0.1,
                onComplete: () => {
                    quote.dataset.splitDone = "true"; // ne pas rejouer
                }
            });
        });
    });
}

const launchSplits = () => {
    setupSplits();
    // Pas besoin de setupSplits() sur chaque refresh si on l’a déjà joué
    setTimeout(() => ScrollTrigger.refresh(), 150);
};

if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(launchSplits);
} else {
    window.addEventListener("load", launchSplits);
}





// Texte appear v2
// Sélectionne tous les conteneurs .text-animate
document.querySelectorAll('.text-animate').forEach(container => {
    const span = container.querySelector('span');

    if (span && span.dataset.text) {
        const textFromPHP = span.dataset.text;

        const tl = gsap.timeline();
        tl.to(span, { duration: 6, text: textFromPHP });
    }
});

